var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoDragIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 11,
    viewBox: "0 0 5 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 0C1.55 0 2 0.45 2 1C2 1.55 1.55 2 1 2C0.45 2 0 1.55 0 1C0 0.45 0.45 0 1 0ZM4 0C4.55 0 5 0.45 5 1C5 1.55 4.55 2 4 2C3.45 2 3 1.55 3 1C3 0.45 3.45 0 4 0ZM1 3C1.55 3 2 3.45 2 4C2 4.55 1.55 5 1 5C0.45 5 0 4.55 0 4C0 3.45 0.45 3 1 3ZM4 3C4.55 3 5 3.45 5 4C5 4.55 4.55 5 4 5C3.45 5 3 4.55 3 4C3 3.45 3.45 3 4 3ZM1 6C1.55 6 2 6.45 2 7C2 7.55 1.55 8 1 8C0.45 8 0 7.55 0 7C0 6.45 0.45 6 1 6ZM4 6C4.55 6 5 6.45 5 7C5 7.55 4.55 8 4 8C3.45 8 3 7.55 3 7C3 6.45 3.45 6 4 6ZM1 9C1.55 9 2 9.45 2 10C2 10.55 1.55 11 1 11C0.45 11 0 10.55 0 10C0 9.45 0.45 9 1 9ZM4 9C4.55 9 5 9.45 5 10C5 10.55 4.55 11 4 11C3.45 11 3 10.55 3 10C3 9.45 3.45 9 4 9Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoDragIcon);
export default __webpack_public_path__ + "static/media/videoDragIcon.6b1390ebca78b7b1bd9c175b4eea8e33.svg";
export { ForwardRef as ReactComponent };